 <template>
  <div>
    <v-app-bar
      flat
      color="transparent"
    >
      <v-toolbar-title>
        In-Article Promos
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-row
        v-if="showSearch"
        align="center"
        style="max-width: 300px;"
      >
        <v-text-field
          flat
          hide-details
          single-line
          label="Search promo name or url"
          class="hidden-sm-and-down"
          v-model="filter.search"
          @input="search"
        ></v-text-field>
      </v-row>
      <v-btn
        class="ml-5"
        icon
        @click="showSearch = !showSearch"
      >
        <img
          src="@/assets/icons/search.svg"
          alt=""
        >
      </v-btn>
    </v-app-bar>
    <div
      class="pa-4"
      id="best-promo-list"
    >
      <v-simple-table>
        <thead>
          <tr>
            <th
              class="text-left"
              @click="sortTable('go_url_title')"
            >
              <div>
                Promo Title
                <v-icon
                  small
                  color="blue darken-2"
                  v-if="tableSort.sortBy === 'go_url_title'"
                >{{ tableSort.icon }}</v-icon>
              </div>
            </th>
            <th>Dimers URL</th>
            <th
              class="text-left"
              @click="sortTable('created_at')"
            >
              <div>
                Date Created
                <v-icon
                  small
                  color="blue darken-2"
                  v-if="tableSort.sortBy === 'created_at'"
                >{{ tableSort.icon }}</v-icon>
              </div>
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(list, i) in recordList"
            :key="i"
            class="hoverable"
          >
            <td @click="editRecord(list.id)">
              {{  list.go_url_title }}
            </td>

            <td
              v-clipboard:copy="copyLink(list.go_url_slug)"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              {{  copyLink(list.go_url_slug) }}
            </td>
            <td>
              {{list.addedDate}}
            </td>

            <td class="text-center">
              <v-menu
                transition="slide-x-transition"
                bottom
                right
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="hoverable"
                    v-bind="attrs"
                    v-on="on"
                  >mdi-dots-vertical</v-icon>
                </template>
                <v-list>
                  <v-list-item class="hoverable">
                    <v-list-item-title
                      v-clipboard:copy="copyLink(list.go_url_slug)"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    >
                      <v-icon>mdi-content-duplicate</v-icon>Copy Link
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item class="hoverable">
                    <v-list-item-title @click="editRecord(list.id)">
                      <v-icon>mdi-file-edit</v-icon>Edit
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item class="hoverable">
                    <v-list-item-title @click="triggerDelete(list.id, i)">
                      <v-icon>mdi-delete</v-icon>Delete
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
          <tr v-if="loading">
            <td
              class="pl-0"
              v-for="n in 3"
              :key="n"
            >
              <v-skeleton-loader type="list-item" />
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <div
        v-if="listMeta.total"
        class="py-5 d-flex justify-center"
      >
        <small class="grey--text lighten-4">
          {{ listMeta.from }}-{{ listMeta.to }} of
          {{ listMeta.total | formatNumber }}
        </small>
      </div>
    </div>
    <div
      class="text-center mt-2 mb-8"
      v-if="listMeta.last_page > 1"
    >
      <v-pagination
        @input="pageChanged"
        :value="listMeta.current_page"
        :length="listMeta.last_page"
        :total-visible="10"
        circle
      ></v-pagination>
    </div>
    <v-overlay
      absolute
      :value="updating"
    >
      <v-dialog
        v-model="updating"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            {{ loading_message }}
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>
    <v-snackbar
      v-model="snackbar.show"
      right
      :color="snackbar.color"
    >
      {{ snackbar.message }}
      <v-btn
        text
        @click="snackbar.show = false"
      >OK</v-btn>
    </v-snackbar>
    <v-btn
      color="success"
      fab
      large
      dark
      bottom
      right
      fixed
      class="mb-4"
      :to="{name: 'in-article-promos.create'}"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-dialog
      v-model="confirmDeleteDialog"
      persistent
      max-width="360"
    >
      <v-card>
        <v-card-title class="headline">
          <p class="confirm-delete">Are you sure you want to delete this record?</p>
        </v-card-title>
        <v-card-text>Delete Record.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="confirmDeleteDialog = false"
          >No</v-btn>
          <v-btn
            @click="deleteInArticlePromo"
            color="red darken-1 white--text"
          >Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import debounce from 'lodash/debounce'

export default {
  name: 'InArticlePromosPage',
  data () {
    return {
      showSearch: false,
      filter: {
        search: ''
      },
      confirmDeleteDialog: false,
      loading: false,
      updating: false,
      loading_message: 'Fetching Data',
      snackbar: {
        show: false,
        message: null,
        color: 'success'
      },
      to_delete_id: null,
      to_delete_index: null,
      tableSort: {
        sortBy: 'created_at',
        sortOrder: 'asc',
        sortString: 'created_at',
        icon: 'mdi-sort-alphabetical-ascending'
      }
    }
  },

  computed: {
    ...mapState({
      recordList: state => state.inArticlePromo.list,
      listMeta: state => state.inArticlePromo.listMeta,
      requestStatus: state => state.inArticlePromo.requestStatus,
      requestMsg: state => state.inArticlePromo.requestMsg
    })
  },

  methods: {
    ...mapActions({
      getList: 'inArticlePromo/getList',
      updateRecord: 'inArticlePromo/update',
      deleteRecord: 'inArticlePromo/delete'
    }),

    editRecord (id) {
      this.$router.push({ name: 'in-article-promos.edit', params: { id } })
    },

    triggerDelete (id, index) {
      this.confirmDeleteDialog = true
      this.to_delete_id = id
      this.to_delete_index = index
    },

    async deleteInArticlePromo () {
      this.updating = true
      this.confirmDeleteDialog = false
      this.loading_message = 'Deleting Record.'
      await this.deleteRecord(this.to_delete_id)
        .then(response => {
          this.recordList.splice(this.to_delete_index, 1)
          this.showSnackbar(this.requestMsg, 'success')
          this.updating = false
        })
        .catch(err => {
          console.log(err)
          this.showSnackbar(this.requestMsg, 'error')
        })
    },

    search: debounce(function () {
      this.fetcRecordList()
    }, 600),

    async fetcRecordList (page = 1) {
      let params = { page }

      params.sort = this.tableSort.sortString
      if (this.filter.search) {
        params.search = this.filter.search
      }

      this.updating = true
      this.loading_message = 'Fetching Data'
      await this.getList(params)
      this.updating = false
    },

    showSnackbar (message, color = 'success') {
      this.snackbar.color = color
      this.snackbar.message = message
      this.snackbar.show = true
    },

    pageChanged (page) {
      this.fetcRecordList(page)
    },

    onCopy () {
      this.showSnackbar('Promo link copied.')
    },

    onError () {
      this.showSnackbar('Failed to copy.', 'error')
    },

    copyLink (slug) {
      return process.env.VUE_APP_WEB_URL + '/go/' + slug
    },

    sortTable (sortBy) {
      if (this.tableSort.sortBy !== sortBy) {
        this.tableSort.sortBy = sortBy
        this.tableSort.sortOrder = 'asc'
        this.tableSort.sortString = sortBy
        this.tableSort.icon = 'mdi-sort-alphabetical-ascending'
      } else {
        this.tableSort.sortBy = sortBy
        if (this.tableSort.sortOrder === 'asc') {
          this.tableSort.sortOrder = 'desc'
          this.tableSort.sortString = '-' + sortBy
          this.tableSort.icon = 'mdi-sort-alphabetical-descending'
        } else {
          this.tableSort.sortOrder = 'asc'
          this.tableSort.sortString = sortBy
          this.tableSort.icon = 'mdi-sort-alphabetical-ascending'
        }
      }
      this.sortRecords()
    },

    sortRecords: debounce(function () {
      this.fetcRecordList()
    }, 600)
  },

  created () {
    this.fetcRecordList()
  },

  filters: {
    formatNumber (value) {
      return Number(value).toLocaleString()
    }
  }
}
</script>

<style scoped>
.hoverable:hover {
  cursor: pointer;
}
tr:hover {
  cursor: pointer;
}
</style>
